import classNames from 'classnames';

import type { ECouponPriceSplashProps } from './ECouponPriceSplash.types';

import styles from './ECouponPriceSplash.module.scss';

const ECouponPriceSplash = (props: ECouponPriceSplashProps) => {
    const { ariaLabel, ariaHidden } = props;

    return (
        <div
            id={props.id}
            aria-label={ariaLabel}
            aria-hidden={ariaHidden}
            className={classNames(
                styles.Container,
                props.theme === 'primary' ? styles.Primary : styles.Secondary,
                props.size === 'small' && styles.SizeSmall,
            )}
            role="figure"
        >
            <svg
                viewBox="0 0 101 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={styles.Svg}
                aria-hidden={ariaLabel ? true : undefined}
            >
                <path
                    d="M29.5949 2.98124C47.5989 1.02915 72.566 -0.688904 100.392 0.277192L98.5503 32.3557C96.5448 32.286 94.5541 32.2331 92.5808 32.1924L91.2642 57.4818C70.8836 56.9379 52.1346 58.5824 38.4482 60.3781C31.6254 61.2733 26.1109 62.1989 22.3426 62.8923C20.4601 63.2387 19.0165 63.5273 18.0672 63.7231C17.5931 63.8209 17.2416 63.8943 17.0217 63.942C16.912 63.9657 16.8342 63.9831 16.7906 63.9927C16.7751 63.9962 16.7636 63.9983 16.7567 64C16.7544 63.9792 16.6436 63.425 13.5377 48.3683C12.5129 43.4001 11.8166 40.0104 11.3401 37.6985C9.61029 37.9784 8.24727 38.2112 7.28743 38.3829C6.70079 38.4879 6.26443 38.5687 5.98654 38.6212C5.84761 38.6474 5.74753 38.6667 5.68885 38.678C5.65975 38.6836 5.63962 38.6859 5.63076 38.6877C5.62789 38.6612 5.51878 38.0325 2.81601 22.952C0.0407803 7.46725 -0.00174146 7.21831 4.14566e-05 7.21386L0.00609209 7.21265C0.010167 7.21185 0.0153644 7.21006 0.0206136 7.20903C0.0315866 7.20688 0.0457476 7.2061 0.0617579 7.20298C0.0943942 7.19659 0.138027 7.18788 0.191241 7.17758C0.298291 7.15688 0.447969 7.12731 0.636568 7.09172C1.01371 7.02057 1.55237 6.92152 2.24362 6.79786C3.6269 6.5504 5.6248 6.20723 8.17324 5.805C13.2687 5.00079 20.5783 3.95887 29.5949 2.98124Z"
                    className={styles.SvgPath}
                />
                <path
                    d="M5.62834 38.6901L5.62592 38.6889H5.63197L5.62834 38.6901Z"
                    className={styles.SvgPath}
                />
            </svg>
            <div
                className={classNames(styles.Text, {
                    [styles.Medium]: props.text.length > 5,
                    [styles.Small]: props.text.length > 7,
                })}
                aria-hidden={ariaLabel ? true : undefined}
            >
                {props.text}
            </div>
        </div>
    );
};

export default ECouponPriceSplash;
